import React from "react";
import "./skeleton.css"; // Ensure pulse CSS is loaded

const BehaviourQuestionSkeleton = ({ count = 9, optionsPerQuestion = 4 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, qIndex) => (
        <div
          key={qIndex}
          className="mb-2 border p-4 rounded-md shadow-sm rounded"
        >
          {/* Question Skeleton */}
          <div
            className="skeleton-label"
            style={{
              width: "80%",
              height: "16px",
              marginBottom: "12px",
              borderRadius: "4px",
            }}
          ></div>

          {/* Options Skeleton */}
          <div className="space-y-2">
            {Array.from({ length: optionsPerQuestion }).map((_, oIndex) => (
              <div key={oIndex} className="flex items-center space-x-2">
                <div
                  className="skeleton-checkbox"
                  style={{
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                  }}
                ></div>
                <div
                  className="skeleton-label"
                  style={{
                    width: "70%",
                    height: "14px",
                    borderRadius: "4px",
                  }}
                ></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default BehaviourQuestionSkeleton;
